import { IonAccordion, IonItem } from "@ionic/react";
import { poleDisplay } from "../Account";
import StatModal from "./StatsModal";

const getPoleTechnologie = (): poleDisplay[] => {
  const techno = localStorage.getItem("techno") ?? "pat";
  switch (techno) {
    case "pat":
      return [
        { name: "Pole 1", number: 1 },
        { name: "Pole 2", number: 2 },
      ];
    case "boul":
      return [{ name: "Savoirs associés", number: 1 }];
    case "char":
      return [{ name: "Pas encore disponible", number: 1, active: false }];

    default:
      return [];
  }
};

const StatsPoleTechnoAccordion: React.FC = () => {
  const polesTechologie = getPoleTechnologie();

  return (
    <IonAccordion style={{ borderRadius: 20, marginTop: 10 }}>
      <IonItem slot="header">Mes notes pour technologie</IonItem>
      <div
        slot="content"
        className="flex ion-justify-content-center"
        style={{
          padding: 10,
        }}
      >
        {polesTechologie.map((pole, index) => {
          return <StatModal key={index} pole={pole} genre={"techno"} />;
        })}
      </div>
    </IonAccordion>
  );
};

export default StatsPoleTechnoAccordion;
